import type { Translations } from '../../../types'

const shopProductsMessages: Translations = {
  "shop.products.catalogEyebrow": "Catalogo",
  "shop.products.title": "Prodotti",
  "shop.products.subtitle": "Monitora il catalogo, aggiorna lo stato dei prodotti e mantieni il listino sempre pronto alla vendita.",
  "shop.products.addButton": "Aggiungi prodotto",
  "shop.products.stats.total": "Totale prodotti",
  "shop.products.stats.active": "Pubblicati",
  "shop.products.stats.draft": "Bozze",
  "shop.products.searchPlaceholder": "Cerca per nome, slug, marca, modello o categoria...",
  "shop.products.categoriesFilter": "Categorie",
  "shop.products.categoriesFilterAll": "(tutte)",
  "shop.products.categoriesFilterTitle": "Filtra categorie",
  "shop.products.categoriesFilterReset": "Reset",
  "shop.products.filteredResults": "Risultati filtrati: {{count}}",
  "shop.products.selectedCategories": "Categorie: {{categories}}",
  "shop.products.filters.all": "Tutti",
  "shop.products.filters.active": "Pubblicati",
  "shop.products.filters.draft": "Bozze",
  "shop.products.filters.archived": "Archiviati",
  "shop.products.filters.secondaryTitle": "Filtri secondari",
  "shop.products.filters.toggle": "Filtri",
  "shop.products.table.product": "Prodotto",
  "shop.products.table.price": "Prezzo",
  "shop.products.table.quantity": "Quantita",
  "shop.products.table.status": "Stato",
  "shop.products.table.createdAt": "Caricato il",
  "shop.products.table.actions": "Azioni",
  "shop.products.table.loading": "Caricamento prodotti...",
  "shop.products.table.empty": "Nessun prodotto trovato.",
  "shop.products.table.noCategory": "Nessuna categoria",
  "shop.products.table.noTimestamp": "-",
  "shop.products.table.lowStockHint": "Sotto soglia · ≤ {{threshold}}",
  "shop.products.table.sortBy": "Ordina per {{column}}",
  "shop.products.table.assignCategoriesFor": "Assegna categorie a {{name}}",
  "shop.products.table.visit": "Visita",
  "shop.products.table.edit": "Modifica",
  "shop.products.table.duplicate": "Duplica prodotto",
  "shop.products.table.delete": "Elimina",
  "shop.products.table.trash": "Sposta nel cestino",
  "shop.products.table.restore": "Ripristina",
  "shop.products.table.deleting": "...",
  "shop.products.table.copyLink": "Copia link",
  "shop.products.table.linkCopied": "Link copiato",
  "shop.products.bulk.selectVisible": "Seleziona pagina",
  "shop.products.bulk.selectFiltered": "Seleziona tutti i risultati ({{count}})",
  "shop.products.bulk.clearFiltered": "Deseleziona risultati filtrati",
  "shop.products.bulk.selectSingle": "Seleziona {{name}}",
  "shop.products.bulk.selected": "{{count}} selezionati",
  "shop.products.bulk.selectedInFiltered": "{{selected}}/{{total}} nel filtro",
  "shop.products.bulk.actionLabel": "Azione massiva",
  "shop.products.bulk.secondaryActions": "Altre azioni",
  "shop.products.bulk.changeStatus": "Cambia stato",
  "shop.products.bulk.status.active": "Pubblicato",
  "shop.products.bulk.status.draft": "Bozza",
  "shop.products.bulk.status.archived": "Archiviato",
  "shop.products.bulk.status.select": "Seleziona",
  "shop.products.bulk.action.assignCategories": "Assegna categorie",
  "shop.products.bulk.action.setActive": "Pubblica",
  "shop.products.bulk.action.setDraft": "Imposta bozza",
  "shop.products.bulk.action.archive": "Sposta nel cestino",
  "shop.products.bulk.action.restore": "Ripristina",
  "shop.products.bulk.pickCategories": "Scegli categorie",
  "shop.products.bulk.editCategories": "Modifica categorie",
  "shop.products.bulk.clearCategories": "Azzera categorie",
  "shop.products.bulk.categoriesSelected": "{{count}} categorie selezionate",
  "shop.products.bulk.categorySearchPlaceholder": "Cerca categoria...",
  "shop.products.bulk.categoryNoResults": "Nessuna categoria trovata",
  "shop.products.bulk.applyCategories": "Conferma categorie",
  "shop.products.bulk.apply": "Applica",
  "shop.products.bulk.applying": "Applicazione...",
  "shop.products.bulk.clear": "Pulisci selezione",
  "shop.products.bulk.confirmSetActive": "Pubblicare {{count}} prodotti selezionati?",
  "shop.products.bulk.confirmSetDraft": "Impostare come bozze {{count}} prodotti selezionati?",
  "shop.products.bulk.confirmAssignCategories": "Assegnare le categorie \"{{categories}}\" a {{count}} prodotti selezionati?",
  "shop.products.bulk.confirmArchive": "Spostare nel cestino {{count}} prodotti selezionati?",
  "shop.products.bulk.confirmRestore": "Ripristinare {{count}} prodotti selezionati?",
  "shop.products.bulk.categoryRequired": "Seleziona una categoria prima di applicare l'azione",
  "shop.products.bulk.setActiveError": "Errore durante la pubblicazione",
  "shop.products.bulk.setDraftError": "Errore durante il passaggio a bozza",
  "shop.products.bulk.assignCategoriesError": "Errore durante l'aggiornamento categorie",
  "shop.products.bulk.archiveError": "Errore durante lo spostamento nel cestino",
  "shop.products.bulk.restoreError": "Errore durante il ripristino",
  "shop.products.bulk.genericError": "Operazione non riuscita",
  "shop.products.bulk.resultSuccess": "{{action}} completata: {{success}}/{{total}}",
  "shop.products.bulk.resultPartial": "{{action}} completata parzialmente: {{success}} ok, {{failed}} errori (su {{total}})",
  "shop.products.bulk.assignDialogTitle": "Assegna categorie",
  "shop.products.bulk.assignDialogBulkDescription": "Seleziona le categorie da applicare ai {{count}} prodotti selezionati.",
  "shop.products.bulk.assignDialogSingleDescription": "Scegli una o piu categorie per questo prodotto.",
  "shop.products.quickFilters.reset": "Reset filtri rapidi",
  "shop.products.quickFilters.label": "Smart filters",
  "shop.products.quickFilters.lowStock": "Stock critico <= {{threshold}} ({{count}})",
  "shop.products.quickFilters.noCategory": "Da categorizzare ({{count}})",
  "shop.products.quickFilters.noImage": "Senza media principale ({{count}})",
  "shop.products.messages.trashed": "{{name}} spostato nel cestino",
  "shop.products.messages.restored": "{{name}} ripristinato in bozza",
  "shop.products.messages.statusUpdated": "{{name}} aggiornato: {{status}}",
  "shop.products.messages.categoriesUpdated": "{{name}} aggiornato con {{count}} categorie",
  "shop.products.messages.duplicated": "{{name}} duplicato",
  "shop.products.messages.duplicateError": "Errore durante la duplicazione del prodotto",
  "shop.products.messages.deleteConfirm": "Eliminare definitivamente \"{{name}}\"? Questa azione non si puo annullare.",
  "shop.products.messages.deleted": "{{name}} eliminato",
  "shop.products.messages.deleteError": "Errore durante l'eliminazione del prodotto",
  "shop.products.pagination.summary": "Pagina {{page}} di {{totalPages}} • {{totalItems}} prodotti",
  "shop.products.pagination.prev": "Indietro",
  "shop.products.pagination.next": "Avanti",
  "shop.products.pagination.show": "Mostra",
  "shop.products.pagination.results": "prodotti",
  "shop.products.pagination.of": "di",
  "shop.products.pagination.page": "Pagina",
  "shop.products.createType.eyebrow": "Nuovo prodotto",
  "shop.products.createType.title": "Che tipo di prodotto vuoi creare?",
  "shop.products.createType.description": "Cerca per etichetta, descrizione o chiave.",
  "shop.products.createType.searchLabel": "Cerca tipi prodotto",
  "shop.products.createType.searchPlaceholder": "Cerca un tipo di prodotto",
  "shop.products.createType.empty": "Nessun tipo di prodotto corrisponde alla ricerca.",
  "shop.products.createType.generic.title": "Generico",
  "shop.products.createType.generic.description": "Prodotto senza Product Type",
  "shop.products.status.active": "Pubblicato",
  "shop.products.status.draft": "Bozza",
  "shop.products.status.archived": "Archiviato",
}

export default shopProductsMessages
